import Layout from '../../components/layout/Layout'

const COF = () => {
  return (
    <Layout>
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">COF</h1>
        <p className="text-gray-600">
          Certificate of Filing information and resources
        </p>
      </div>
    </Layout>
  )
}

export default COF
